<div
  class="con"
  [ngClass]="{
    container: isMoveTree
  }"
>
  @if (!isMoveTree) {
  <ion-searchbar
    [placeholder]="'fileTree.search' | translate"
    show-clear-button="focus"
    [ngModel]="searchTerm$ | async"
    (ngModelChange)="setSearchTerm($event)"
  ></ion-searchbar>
  }
  <div style="width: 100%; display: flex; justify-content: space-between">
    <ion-breadcrumbs style="width: 100%">
      @for (node of breadcrumbs; track node) {
      <ion-breadcrumb style="cursor: pointer" (click)="goToBreadcrumb(node)">{{
        node.displayName
      }}</ion-breadcrumb>
      }
    </ion-breadcrumbs>
  </div>

  <div class="doc-list">
    <div class="sort-info-section">
      @if (breadcrumbs.length == 1 && !(searchTerm$ | async)) {
      <div>
        {{ (this.currentItems$ | async)?.length }} {{ ALLITEMS }} gefunden
      </div>
      } @if (breadcrumbs.length > 1) {
      <div>{{ (this.currentItems$ | async)?.length }} Ergebnisse</div>
      } @if ( breadcrumbs.length == 1 && (currentFolderId$ | async) ==
      this.state.magicNumber && (searchTerm$ | async) ) {
      <div>
        {{ (this.currentItems$ | async)?.length }} Ergebnisse in allen
        {{ ALLITEMS }}
      </div>
      } @if(showFilters){
      <div style="display: flex; align-items: center">
        @if((currentFolderId$ | async) == state.magicNumber && conSitesMode){
        <ion-select
          style="width: 120px"
          [value]="0"
          (ionChange)="selectedStateChange($event.detail.value)"
          [label]="'fileTree.constructionStatus' | translate"
          label-placement="floating"
          interface="action-sheet"
          [cancelText]="'common.cancel' | translate"
        >
          @for (val of constructionSiteStates; track val) {
          <ion-select-option [value]="val.value">
            {{ val.label }}</ion-select-option
          >
          }
        </ion-select>
        }
        <ion-select
          style="width: 160px; margin-left: 10px"
          [label]="'fileTree.sorting' | translate"
          label-placement="floating"
          (ionChange)="sortChange($event)"
          interface="action-sheet"
          [value]="selectedSortOption.value"
          [cancelText]="'common.cancel' | translate"
        >
          @for (sortOption of this.sortOptions; track sortOption) {
          <ion-select-option [value]="sortOption">{{
            sortOption.label
          }}</ion-select-option>
          }
        </ion-select>
      </div>
      } @if(!state.isBigScreen){
      <ion-icon
        (click)="showFilters = !showFilters"
        style="font-size: 24px"
        name="funnel-outline"
      ></ion-icon>
      }
    </div>
  </div>
  <div
    class="custom-table"
    [ngClass]="{
      'custom-table-move': isMoveTree,
      'custom-table-basic': !isMoveTree && state.isBigScreen,
      'custom-table-basic-mobile': !isMoveTree && !state.isBigScreen
    }"
  >
    <div class="row header">
      @if (!isMoveTree) {
      <div class="col" style="display: flex; align-items: center">
        <ion-checkbox
          [checked]="allSelected"
          (ionChange)="toggleAll()"
          (click)="$event.stopPropagation()"
          [disabled]="!state.userHasMinType(1)"
        ></ion-checkbox>
      </div>
      }
      <div class="col">
        @if(breadcrumbs.length != 1 || !conSitesMode){
        <ion-icon name="folder-outline"></ion-icon>
        }@else{
        <ion-icon name="construct-outline"></ion-icon>
        }
      </div>
      <div class="col grow">Name</div>
      @if (!isMoveTree && state.isBigScreen) {
      <div class="col">Elemente</div>
      } @if (!isMoveTree && state.isBigScreen) {
      <div class="col">Datum</div>
      }

      <!--div class="col">Geändert</div-->
    </div>

    @for (doc of currentItems$ | async; track doc) {
    <div
      class="row"
      [ngClass]="{
        disabled: itemsToMove.includes(doc),
        'last-clicked': doc.id && doc.id === lastClickedItemId
      }"
    >
      @if (!isMoveTree) {
      <div class="col">
        <ion-checkbox
          [checked]="isSelected(doc)"
          (click)="$event.stopPropagation()"
          (ionChange)="toggleSelection(doc)"
          [disabled]="!state.userHasMinType(1)"
        ></ion-checkbox>
      </div>
      }
      <div class="col" (click)="itemClicked(doc)">
        <ion-icon [name]="getIcon(doc)"></ion-icon>
      </div>
      <div class="col grow" (click)="itemClicked(doc)">
        {{ doc.displayName }}
      </div>
      @if(!isMoveTree && state.isBigScreen){
      <div class="col" (click)="itemClicked(doc)">
        @if(doc.fileExtension){ - } @else{ {{ doc.childrenCount }} }
      </div>
      } @if(!isMoveTree && state.isBigScreen){
      <div class="col">{{ doc.createdUtc | date : "dd.MM.yyyy" }}</div>
      }
    </div>
    }
    <!--div
          class="row"
          *ngIf="(currentItems$ | async)?.length == 0 && breadcrumbs.length > 1"
          (click)="goBack()"
          >
          <div class="col">
            <ion-icon
              style="font-size: 18px; color: white"
              *ngIf="breadcrumbs.length <= 1"
              name="square-outline"
            ></ion-icon>
          </div>
          <div class="col"><ion-icon name="arrow-undo-outline"></ion-icon></div>
          <div class="col grow">Zurück</div>
        </div-->
  </div>
</div>
